import {
  createStyles,
  Fade,
  Paper,
  Snackbar,
  SnackbarContent,
  Theme,
  WithStyles,
  withStyles,
} from '@material-ui/core'
import { green } from '@material-ui/core/colors'
import * as R from 'ramda'
import React from 'react'
import { RouteComponentProps } from 'react-router'

import { getActivityById } from '../../services/enrollment.service'
import ActivityOutcomeFormPicker from './../../Forms/Outcomes/FormItems/ActivityOutcomesFormPicker'
import { ActivityOutcome } from './../../services/Model/Outcome'
import { getActivityOutcomes, updateActivityOutcomes } from './../../services/outcomes.service'
import DefaultLoaderModal from './../DefaultLoaderModal/DefaultLoaderModal'

interface ParticipantOutcomesLandingProps extends WithStyles<typeof styles> { }

export type RouterProps = ParticipantOutcomesLandingProps &
  RouteComponentProps<{
    activityID: string
    participantID: string
  }>

export const ParticipantOutcomesLanding: React.FC<RouterProps> = (props: RouterProps) => {
  const { classes, match, history } = props
  const { activityID } = match.params

  const [loading, setLoading] = React.useState(true)
  const [loadingData, setLoadingData] = React.useState(true)
  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: 'Record Updated Successfully',
    type: 'success',
  })
  const [outcomes, setOutcomes] = React.useState<ActivityOutcome>()
  const [currentActivity, setCurrentActivity] = React.useState()

  const getInitialOutcomes = (o: ActivityOutcome) => {
    const credentialType = o.credentialType || "Unknown"
    const academicCredit = o.academicCredit || "Unknown"

    return {
      ...o,
      credentialType,
      academicCredit
    }
  }


  const handleApiResponse = (status: 'error' | 'success', snackAlert?: boolean): any => {
    const snackBarStatus =
      status === 'success'
        ? { open: true, type: 'success', message: 'Outcomes updated' }
        : { open: true, type: 'error', message: 'Something went wrong' }

    setLoadingData(false)
    setLoading(false)
    if (snackAlert) setSnackbar(snackBarStatus)
  }


  const onActivityUpdate = (updatedActivityData: ActivityOutcome) => {
    setLoadingData(true)
    const id = currentActivity ? currentActivity!['id'] : 0

    console.log(">>", updatedActivityData)

    updateActivityOutcomes(id.toString(), updatedActivityData)
      .then(() => {
        getActivityOutcomes(activityID)
          .then((updatedOutcomes) => {
            setOutcomes(getInitialOutcomes(updatedOutcomes))
            setTimeout(() => {
              handleApiResponse('success', true)
              setTimeout(() => {
                history.goBack()
              }, 600);
            }, 100)
          })
          .catch((err) => {
            handleApiResponse('error', true)
          })
      })
      .catch(() => {
        handleApiResponse('error', true)
      })
  }

  function handleClose(event?: React.SyntheticEvent, reason?: string) {
    if (reason === 'clickaway') {
      return
    }

    setSnackbar({ ...snackbar, open: false })
  }

  React.useEffect(() => {
    getActivityOutcomes(activityID)
      .then((o) => {
        setOutcomes(getInitialOutcomes(o))
        handleApiResponse('success')
      })
      .catch(() => {
        handleApiResponse('error')
      })
  }, [activityID])

  React.useEffect(() => {
    getActivityById(activityID)
      .then(setCurrentActivity)
      .catch((e: any) => null)
  }, [activityID])

  return (
    <div className={classes.root}>
      <DefaultLoaderModal loading={loadingData} />
      <Fade in={!loading} timeout={{ enter: 1000 }}>
        <Paper elevation={2} style={{ padding: '16px' }}>
          {
            R.and(!!outcomes, !!currentActivity) && (
              <section className={classes.forms}>
                <div className={classes.formWrapper}>
                {
                  ActivityOutcomeFormPicker(onActivityUpdate, history.goBack, currentActivity, outcomes)
                }
                </div>
              </section>
            )
          }
        </Paper>
      </Fade>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={snackbar.open}
        autoHideDuration={5000}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
        onClose={handleClose}
      >
        <SnackbarContent
          className={classes[snackbar.type]}
          aria-describedby="client-snackbar"
          message={
            <span id="client-snackbar" className={classes.message}>
              {snackbar.message}
            </span>
          }
        />
      </Snackbar>
    </div>
  )
}

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    progress: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: '-20px',
      marginLeft: '-20px',
    },
    success: {
      backgroundColor: green[600],
    },
    error: {
      backgroundColor: theme.palette.error.dark,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'transparent',
    },
    forms: {
      display: 'flex',
      justifyContent: 'center',
    },
    formWrapper: {
      flexBasis: '65%',

      [theme.breakpoints.down('sm')]: {
        flexBasis: '95%',
      },
    },
  })

export default withStyles(styles)(ParticipantOutcomesLanding)
